export default __webpack_public_path__ + "static/media/appStore-es.b848ded6.svg";